import basicController from "servicestack/basic.controller.properties";
import resolve from "ng";
import alert from "webmodals/alert";
import authConfig from "emun.auth/auth.config"; //get shared

export default class ResetPasswordController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
    $ctrl.config = authConfig;
    delete $ctrl.bus.validationErrors;
    console.debug("ResetPasswordController", this);
  }

  $onInit() {
    const $ctrl = this;
    if (!$ctrl.request) {
      $ctrl.request = {
        callbackUrl: $ctrl.callbackUrl,
        email: null
      };
    }
  }

  submit() {
    let $ctrl = this;
    const $notify = resolve("notify");
    return $ctrl.$session.bus.send(`ResetPassword.json`, $ctrl.request).then(
      res => {
        // alert("Please check your email to reset your password");
        $ctrl.$dismiss && $ctrl.$dismiss("resetPassword", res.data);
        $ctrl.onSuccess && $ctrl.onSuccess(res.data);
        $notify.success("Please check your email to reset your password", {
          title: "Reset Password",
          ttl: 5000,
          disableCountDown: true
        });
      },
      failed => {
        alert("This email address is not on file in our system");
        $ctrl.onFail && $ctrl.onFail(failed.data.responseStatus);
        $ctrl.errors = failed.data.responseStatus;
      }
    );
  }
}
